<template>
  <path
    d="M22 11.0002V13.0002H9V9.00024C9 7.90024 9.9 7.00024 11 7.00024H18C20.21 7.00024 22 8.79024 22 11.0002ZM2 15.0002C2 15.5502 2.45 16.0002 3 16.0002H8V17.0002C8 17.5502 8.45 18.0002 9 18.0002H15C15.55 18.0002 16 17.5502 16 17.0002V16.0002H21C21.55 16.0002 22 15.5502 22 15.0002C22 14.4502 21.55 14.0002 21 14.0002H3C2.45 14.0002 2 14.4502 2 15.0002ZM7.14 12.1002C8.3 10.9102 8.28 9.02024 7.1 7.86024C5.91 6.70024 4.02 6.72024 2.86 7.90024C1.7 9.09024 1.72 10.9802 2.9 12.1402C4.09 13.3002 5.98 13.2802 7.14 12.1002Z"
  />
</template>
